import { kenburns } from "./lib/kenBurns.js";
import { searchAvailableDates } from "./lib/searchAvailableDates";
import { propDescriptionReadMore } from "./lib/propDescriptionReadMore.js";
import { bs5Lightbox } from "./lib/bs5Lightbox.js";

document.addEventListener("DOMContentLoaded", function () {
  /**
   * We can run the Slideshow (slippry) on the home page if the screen is bigger than 768px
   */
  const mediaQuery = window.matchMedia("(min-width: 768px)");
  // Check if the media query is true
  if (mediaQuery.matches) {
    // Then trigger an alert
    if (document.getElementById("hero-slide-show"))
      kenburns(document.getElementById("hero-slide-show"));
  }

  /**
   * We can run the Hotel DatePicker on the home page
   */
  if (document.getElementById("search-checkin-checkout"))
    searchAvailableDates();

  /**
   * Property Description actions (Read More and Property Gallery)
   */

  if (document.querySelector("#description-title .property_description"))
    propDescriptionReadMore();

  if (document.querySelector(".airbnb")) bs5Lightbox();
});
